export * from './content.component';
